export const REQUESTED = 'requested';
export const ACTIVATED = 'activated';
export const REJECTED = 'rejected';

export const SOCIAL_MEDIA = 'Social Media';
export const SOCIAL_REVIEW = 'Review Sites';
export const SHORT_CODE = 'Shortcode';

export const ADDONS = [
  {
    addOnName: SOCIAL_MEDIA,
    logo: 'share-alt',
    addon_price_id: 1,
  },
  {
    addOnName: SOCIAL_REVIEW,
    logo: 'pen-square',
    addon_price_id: 2,
  },
  // {
  //   addOnName: SHORT_CODE,
  //   logo: 'comment',
  //   addon_price_id: 3,
  // },
];



// WEBPACK FOOTER //
// ./src/constants/AddOns.js